import { businessQuotesService } from '@/services/quotes/business';
import type { AttachBusinessQuotePayload } from '@/services/quotes/types';
import { ValidationError } from '@/shared/exceptions/validation.error';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateBusinessQuote() {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; data?: any; error?: string; message?: string },
    Error | ValidationError,
    { id: string; payload: Partial<AttachBusinessQuotePayload> }
  >({
    mutationKey: ['quotes', 'update', 'business'],
    // 422 (ValidationError) é erro determinístico de validação do attach-element:
    // reenviar a mesma request nunca vai passar, então não fazemos retry.
    retry: (failureCount, error) =>
      !(error instanceof ValidationError) && failureCount < 1,
    mutationFn: async ({ id, payload }) => {
      const stepCode = payload.step?.trim();
      const enrichedPayload: Partial<AttachBusinessQuotePayload> = stepCode
        ? { ...payload, validationEventCode: stepCode }
        : payload;
      const response = await businessQuotesService.updateQuote(
        id,
        enrichedPayload
      );
      if (!response.success) throw new Error(response.error || 'Erro');
      return response;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.id],
      });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
    },
  });
}
